import React, { useEffect,useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Dashboard from "../../layouts/Dashboard";
import * as Yup from "yup";
import Axios from "axios";
import url from "../../services/url";
import { useHistory } from "react-router-dom";
import saveLog from "../../services/saveLog";
import isConsultant from "../../services/isConsultant";
import locations from "../../utils/api/locations";

const initialValues = {
  position: "New",
  vacancy: "Resignation",
  trfRaisedDate: new Date(),
  grade: "G1",
  title: "", // Job Title
  department: "",
  location: "Amritsar",
  reportsTo: "",
  supervises: "",
  travel: "Yes",
  travelLocation: "",
  travelDays: "",
  salary: "",
  numberOfVacancies: "",
  minimumAge: "",
  maximumAge: "",
  gender: "Male",
  experienceRequired: "",
  desiredQualification: "",
  targetIndustry: "",
  targetOrganization: "",
  careerPathPotential: "",
  topPerformer: "", // Why would top perform want this job?
  promotionable: "Yes",
  promotionableReason: "",
  overview: "",
  rolesAndResponsibilities: "",
  desiredCandidateProfile: "",
  competencies: "",
  skills: "",
};

const validationSchema = Yup.object({
  position: Yup.string().required("Required"),
  vacancy: Yup.string().required("Required"),
  trfRaisedDate: Yup.date().required("Required"),
  tat: Yup.date().required("Required"),
  grade: Yup.string().required("Required"),
  title: Yup.string()
    .required("Required")
    .max(100, "Title must not exceed ${max} characters."),
  department: Yup.string()
    .required("Required")
    .max(50, "Department must not exceed ${max} characters."),
  location: Yup.string().required("Required"),
  reportsTo: Yup.string()
    .required("Required")
    .max(50, "Reports To must not exceed ${max} characters."),
  supervises: Yup.string()
    .required("Required")
    .max(100, "Span of Control must not exceed ${max} characters."),
  travel: Yup.string().required("Required"),
  travelLocation: Yup.string().max(
    50,
    "Department must not exceed ${max} characters."
  ),
  travelDays: Yup.number().max(
    31,
    "Please enter a number lower than 32. It is travel days per month."
  ),
  salary: Yup.string()
    .required("Required")
    .max(50, "Salary must not exceed ${max} characters."),
  numberOfVacancies: Yup.number().required("Required"),
  minimumAge: Yup.number().required("Required"),
  maximumAge: Yup.number().required("Required"),
  gender: Yup.string().required("Required"),
  experienceRequired: Yup.number().required("Required"),
  desiredQualification: Yup.string()
    .required("Required")
    .max(100, "Desired Qualification must not exceed ${max} characters."),
  targetIndustry: Yup.string()
    .required("Required")
    .max(100, "Target Industry must not exceed ${max} characters."),
  targetOrganization: Yup.string()
    .required("Required")
    .max(100, "Target Organization must not exceed ${max} characters."),
  careerPathPotential: Yup.string()
    .required("Required")
    .max(200, "Career Path Potential must not exceed ${max} characters."),
  topPerformer: Yup.string()
    .required("Required")
    .max(200, "The above answer must not exceed ${max} characters."),
  promotionable: Yup.string().required("Required"),
  promotionableReason: Yup.string().max(
    200,
    "The above answer must not exceed ${max} characters."
  ),
  overview: Yup.string()
    .required("Required")
    .max(500, "Overview must not exceed ${max} characters."),
  rolesAndResponsibilities: Yup.string()
    .required("Required")
    .max(1000, "The above answer must not exceed ${max} characters."),
  desiredCandidateProfile: Yup.string()
    .required("Required")
    .max(1000, "The above answer must not exceed ${max} characters."),
  competencies: Yup.string()
    .required("Required")
    .max(1000, "The above answer must not exceed ${max} characters."),
  skills: Yup.string().required("Required"),
});

function TalentRequisitionForm() {
  const [preferredLocation, setPreferredLocation] = useState([]);
  // const [form, handleChange, getValue] = useForm();

  useEffect(() => {
    locations().then((res) => {
      setPreferredLocation(res);
    });
  }, []);
  const history = useHistory();

  const onSubmit = (values) => {
    saveLog("TRF_CREATE", `Created '${values.title}'`);
    Axios.post(url("/trf"), values, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((res) => {
        history.push("/trf");
      })
      .catch(alert);
  };
  return (
    <div>
    {!isConsultant() && <Dashboard title="Talent Requisition Form">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <Form>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="position">Position</label>
                <Field as="select" className="form-control" name="position">
                  <option value="New">New</option>
                  <option value="Replacement">Replacement</option>
                </Field>
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="position"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="vacancy">Vacancy Caused due to</label>
                <Field
                  as="select"
                  className="form-control"
                  id="vacancy"
                  name="vacancy"
                >
                  <option value="Resignation">Resignation</option>
                  <option value="Additional Assignemnt">
                    Additional Assignemnt
                  </option>
                  <option value="Work Load">Work Load</option>
                </Field>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="trfRaisedDate">TRF Raised Date</label>
                <Field
                  id="trfRaisedDate"
                  name="trfRaisedDate"
                  className="form-control"
                  type="date"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="trfRaisedDate"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="grade">Grade</label>
                <Field
                  as="select"
                  name="grade"
                  id="grade"
                  className="form-control"
                >
                  <option value="G1">G1</option>
                  <option value="G2">G2</option>
                  <option value="G3">G3</option>
                  <option value="G4">G4</option>
                  <option value="G5">G5</option>
                  <option value="G6">G6</option>
                  <option value="G7">G7</option>
                  <option value="G8">G8</option>
                  <option value="G9">G9</option>
                  <option value="G10">G10</option>
                  <option value="G11">G11</option>
                  <option value="G12">G12</option>
                  <option value="G13">G13</option>
                  <option value="G14">G14</option>
                  <option value="G15">G15</option>
                </Field>
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="grade"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="title">Job Title</label>
                <Field
                  id="title"
                  name="title"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="title"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="department">Department</label>
                <Field
                  id="department"
                  name="department"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="department"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="location">Location</label>
                <Field
                  as="select"
                  name="location"
                  id="location"
                  className="form-control"
                >
                  <option selected value="">
                    Select Location...
                  </option>
                  {preferredLocation?.map((ele) => (
                    <option value={ele?.locationName}>
                      {ele?.locationName}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="location"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="reportsTo">Reports To</label>
                <Field
                  id="reportsTo"
                  name="reportsTo"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="reportsTo"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="skills">Skills (Seperate with comma)</label>
                <Field
                  id="skills"
                  name="skills"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="skills"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="supervises">Span of Control</label>
                <Field
                  id="supervises"
                  name="supervises"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="supervises"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="travel">Travel on Job</label>
                <Field
                  as="select"
                  name="travel"
                  id="travel"
                  className="form-control"
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="travel"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="travelLocation">
                  Travel Location [If Travel is Yes]
                </label>
                <Field
                  id="travelLocation"
                  name="travelLocation"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="travelLocation"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="travelDays">
                  Travel Days per month [If Travel is Yes]
                </label>
                <Field
                  id="travelDays"
                  name="travelDays"
                  className="form-control"
                  type="number"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="travelDays"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="salary">Salary Grade (Annual)</label>
                <Field
                  id="salary"
                  name="salary"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="salary"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="numberOfVacancies">Number of Vacancies</label>
                <Field
                  id="numberOfVacancies"
                  name="numberOfVacancies"
                  className="form-control"
                  type="number"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="numberOfVacancies"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="minimumAge">Minimum Age</label>
                <Field
                  id="minimumAge"
                  name="minimumAge"
                  className="form-control"
                  type="number"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="minimumAge"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="maximumAge">Maximum Age</label>
                <Field
                  id="maximumAge"
                  name="maximumAge"
                  className="form-control"
                  type="number"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="maximumAge"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="gender">Gender</label>
                <Field
                  as="select"
                  name="gender"
                  id="gender"
                  className="form-control"
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Any">Any</option>
                </Field>
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="gender"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="experienceRequired">
                  Total Experience Required in Years
                </label>
                <Field
                  id="experienceRequired"
                  name="experienceRequired"
                  className="form-control"
                  type="number"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="experienceRequired"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="desiredQualification">
                  Desired Qualification
                </label>
                <Field
                  id="desiredQualification"
                  name="desiredQualification"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="desiredQualification"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="targetIndustry">Target Industry</label>
                <Field
                  id="targetIndustry"
                  name="targetIndustry"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="targetIndustry"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="targetOrganization">Target Organizations</label>
                <Field
                  id="targetOrganization"
                  name="targetOrganization"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="targetOrganization"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="careerPathPotential">
                  Career Path Potential
                </label>
                <Field
                  id="careerPathPotential"
                  name="careerPathPotential"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="careerPathPotential"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="topPerformer">
                  Why would a top performer want this job?
                </label>
                <Field
                  id="topPerformer"
                  name="topPerformer"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="topPerformer"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="promotionable">
                  Can vacancy filled through internal transfer/promotions?
                </label>
                <Field
                  as="select"
                  id="promotionable"
                  name="promotionable"
                  className="form-control"
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="promotionable"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="promotionableReason">
                  If not, why cannot vacancy be filled through internal
                  transfer/promotions?
                </label>
                <Field
                  id="promotionableReason"
                  name="promotionableReason"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="promotionableReason"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="overview">Position Overview</label>
                <Field
                  as="textarea"
                  id="overview"
                  name="overview"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="overview"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="rolesAndResponsibilities">
                  Roles and Responsibilities
                </label>
                <Field
                  as="textarea"
                  id="rolesAndResponsibilities"
                  name="rolesAndResponsibilities"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="rolesAndResponsibilities"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="desiredCandidateProfile">
                  Desired Candidate Profile
                </label>
                <Field
                  as="textarea"
                  id="desiredCandidateProfile"
                  name="desiredCandidateProfile"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="desiredCandidateProfile"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="competencies">Competencies</label>
                <Field
                  as="textarea"
                  id="competencies"
                  name="competencies"
                  className="form-control"
                  type="text"
                />
                <ErrorMessage
                  render={(msg) => <div className="trf-error">{msg}</div>}
                  name="competencies"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <button className="btn btn-primary" type="submit">
                  Create
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Formik>
    </Dashboard>}
    </div>
  );
}

export default TalentRequisitionForm;
